import { render, staticRenderFns } from "./PortalDesignerFields.vue?vue&type=template&id=76fa2198&"
import script from "./PortalDesignerFields.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerFields.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesignerFields.vue?vue&type=style&index=0&id=76fa2198&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fa2198')) {
      api.createRecord('76fa2198', component.options)
    } else {
      api.reload('76fa2198', component.options)
    }
    module.hot.accept("./PortalDesignerFields.vue?vue&type=template&id=76fa2198&", function () {
      api.rerender('76fa2198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerFields.vue"
export default component.exports